import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Typography = ({
  className: classNameProp,
  component: componentProp,
  variant,
  children,
  fontWeight,
  ...other
}) => {
  const className = classNames(
    'Typography',
    {
      [`text-variant-${variant}`]: variant,
    },
    classNameProp
  )
  const Component = componentProp || 'span'
  return (
    <Component className={className} {...other}>
      { children }
      <style jsx>
        {`
          .Typography {
            margin: 0;
            line-height: ${Component === 'p' ? 2 : 1.5};
            font-weight: ${fontWeight};
            &.text-variant-big {
              font-size: 40px;
            }

            &.text-variant-title {
              font-size: 32px;
              margin-bottom: 24px;
              font-weight: 700;
              color: #0c2846;
              &.text-variant-title-sm {
                font-size: 28px;
              }
            }

            &.text-variant-subheading {
              font-size: 16px;
            }

            &.text-variant-headline {
              font-size: 20px;
            }

            &.text-variant-subheadline {
              font-size: 16px;
              color: #6b8fbc;
            }
            &.text-variant-body {
              font-size: 16px;
            }
            &.text-variant-subbody {
              font-size: 14px;
              color: #6b8fbc;
            }
            &.text-variant-caption {
              font-size: 12px;
            }
            &.text-variant-note {
              font-size: 10px;
            }
          }
        `}
      </style>
    </Component>
  )
}

Typography.propTypes = {
  className: PropTypes.string,
  fontWeight: PropTypes.string,
  component: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
  variant: PropTypes.oneOf(['big', 'title', 'title-sm', 'subheading', 'headline', 'subheadline', 'body', 'subbody', 'caption', 'note']),
}

Typography.defaultProps = {
  variant: 'body',
  fontWeight: 'normal',
}

export default Typography
